<template>
  <div class="business-settings-inline-form">
    <v-form ref="editCompanyForm"
      @submit.prevent="submit"
      @input="change = true">
      <v-card tile
        flat
        color="white"
        :class="[
          { 'mobile-card': $vuetify.breakpoint.smAndDown },
          { 'card-company': !$vuetify.breakpoint.smAndDown },
        ]">
        <v-card-text style="padding: 0; margin: 0;">
          <v-container>
            <v-tabs class="pill-tabs"
              v-model="tab"
              @change="changeTab(tab)">
              <v-tab
                v-for="oneTab of tabs"
                :key="oneTab.id">
                <v-icon v-if="oneTab.name === 'Osnovni podaci' && !basicDataValid"
                  color="red" size="16" class="mr-1">mdi-alert-circle</v-icon>

                <v-icon v-if="oneTab.name === 'Banka' && !bankDataValid"
                  color="red" size="16" class="mr-1">mdi-alert-circle</v-icon>

                <v-icon v-if="oneTab.name === 'Poslovni podaci' && !legalInfoValid"
                  color="red" size="16" class="mr-1">mdi-alert-circle</v-icon>
                <v-icon size="16" class="pr-1">{{ oneTab.icon }}</v-icon>
                <span>{{ oneTab.name }}</span>
              </v-tab>
            </v-tabs>
            <v-tabs-items style="height: 100% !important"
              v-model="tab">
              <v-tab-item>
                <v-row class="pt-5">
                  <v-col cols="6"
                    class="pt-0 pb-3 mb-0 mt-0">
                    <v-text-field class="textField form-input"
                      dense
                      hide-details
                      outlined
                      label="Naziv"
                      v-model="editableCompany.name"
                      :rules="[rules.req]">
                    </v-text-field>
                  </v-col>
                  <v-col cols="6"
                    class="pt-0 pb-3 mb-0 mt-0">
                    <v-text-field autofocus
                      hide-details
                      dense
                      class="textField form-input"
                      outlined
                      label="OIB"
                      id="oib"
                      v-mask="'###########'"
                      v-model="editableCompany.oib"
                      :rules="[rules.req, rules.oib]"
                      ref="oib"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="pb-2">
                  <v-col cols="6"
                    class="pt-0 mt-0 pb-3 mb-0">
                    <v-text-field dense
                      hide-details
                      class="textField form-input"
                      outlined
                      label="Adresa"
                      v-model="editableCompany.address"
                      :rules="[rules.req]">
                    </v-text-field>
                  </v-col>
                  <v-col cols="6"
                    class="pt-0 mt-0 pb-3 mb-0">
                    <v-text-field dense
                      outlined
                      hide-details
                      class="textField form-input"
                      label="Grad"
                      v-model="editableCompany.city"
                      :rules="[rules.req]">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="pt-2 mt-0 pb-2">
                  <v-col cols="6"
                    class="pt-0 mt-0 pb-0 mb-0">
                    <v-text-field dense
                      outlined
                      class="textField form-input"
                      label="Poštanski broj"
                      hide-details
                      v-model="editableCompany.zip_code"
                      :rules="[rules.req]">
                    </v-text-field>
                  </v-col>
                  <v-col cols="6"
                    class="pt-0 mt-0 pb-0 mb-0">
                    <v-select class="textField form-input"
                      dense
                      hide-details
                      outlined
                      label="Država"
                      v-model="editableCompany.country"
                      :items="countries"
                      item-text="country"
                      item-value="country"
                      :rules="[rules.req]">
                    </v-select>
                  </v-col>
                </v-row>
                <v-row class="pt-5 mt-0">
                  <v-col cols="6"
                    class="pt-0">
                    <v-combobox class="textField form-input"
                      outlined
                      autocomplete="off"
                      dense
                      v-model="selectedOibs"
                      :items="[]"
                      label="PDV Id"
                      multiple
                      chips
                      clearable
                      @click="openAddOibForm"
                      @keypress.enter="openAddOibForm"
                      @keydown="preventTextInput('oib', $event)">
                      <template v-slot:selection="{ item }">
                        <v-chip class="mt-1 mr-0"
                          close
                          @click:close="removeOib(item)">
                          <v-avatar>
                            <country-flag :country="item.countryCode ||
                              item.countryCode.toLowerCase()
                              " />
                          </v-avatar>
                          <span class="ml-2">{{ item.oib }}</span>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col cols="6"
                    class="pt-0">
                    <v-select dense
                      outlined
                      label="Tip firme"
                      :items="companyTypes"
                      v-model="editableCompany.type"
                      item-text="name"
                      item-value="value"
                      :rules="[rules.req]"
                      class="companyType form-input"
                      @change="changeCompanyType">
                    </v-select>
                  </v-col>
                </v-row>
                <v-row class="pt-0 mt-0">
                  <v-col cols="6"
                    class="pt-0 mt-0">
                    <v-select dense
                      class="textField form-input"
                      :items="taxTypes"
                      v-model="editableCompany.tax_type"
                      :label="$t('$vuetify.companies.taxType')"
                      outlined
                      item-text="name"
                      item-value="value">
                    </v-select>
                  </v-col>
                  <v-col class="py-0 pt-0 mt-0"
                    cols="6">
                    <v-checkbox dense
                      outlined
                      class="pt-0 mt-0 textField"
                      label="Firma je u sustavu PDV-a"
                      color="#00BCD4"
                      v-model="editableCompany.is_taxed">
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row class="pt-3"
                  style="text-align: center">
                  <v-col>
                    <v-row class="pb-3 pr-3">
                      <v-spacer></v-spacer>
                      <v-btn v-if="
                        editableCompany.bank_accounts &&
                        editableCompany.bank_accounts.length > 0
                      "
                        fab
                        class="fab-add-btn mb-2"
                        @click="openIbanForm"
                        style="
                          width: 25px;
                          height: 25px;
                          padding: 0px;
                          border-radius: 50%;
                        "><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                    </v-row>

                    <table v-if="
                      editableCompany.bank_accounts &&
                      editableCompany.bank_accounts.length > 0
                    "
                      class="styled-table"
                      style="width: 100%">
                      <thead>
                        <tr>
                          <th width="30%"
                            colspan="1">IBAN</th>
                          <th width="35%"
                            colspan="1">Naziv banke</th>
                          <th width="20%"
                            colspan="1">Glavni Iban</th>
                          <th width="25%"
                            colspan="1"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="bank in editableCompany.bank_accounts"
                          :key="bank.id">
                          <td style="text-align: left"
                            colspan="1">
                            {{ bank.iban }}
                          </td>
                          <td colspan="1">{{ bank.bank.name }}</td>
                          <td colspan="1">{{ showMainIban(bank.default) }}</td>
                          <td style="text-align: right"
                            colspan="1">
                            <v-icon class="pr-2 row-action-icon"
                              @click="editIban(bank)">mdi-pencil-outline</v-icon>
                            <v-icon class="row-action-icon row-action-icon--delete"
                              @click="removeIban(bank)">mdi-delete-outline</v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-col>
                </v-row>
                <v-row v-if="
                  !editableCompany.bank_accounts || editableCompany.bank_accounts.length === 0
                "
                  style="justify-content: center; margin-top: 50px">
                  <v-btn class="btn-primary"
                    @click="openIbanForm"><v-icon color="#fff"
                      class="pr-1">mdi-plus</v-icon>Dodaj IBAN</v-btn>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row class="pt-3 pr-3"
                  style="text-align: center">
                  <v-col class="d-flex justify-center pt-0">
                    <v-img style="border: 1px solid #E2E8F0; border-radius: 8px"
                      :src="editableCompany.logo"
                      v-model="editableCompany.logo"
                      contain
                      max-height="116"
                      max-width="256"
                      ref="image"
                      :lazy-src="require('@/assets/unknown_profile.jpg')"></v-img>
                  </v-col>
                  <v-col class="pt-2 mt-1">
                    <v-file-input class="pt-1 form-input"
                      outlined
                      dense
                      style="overflow: hidden"
                      label="Logo"
                      @change="onFileChange"
                      clearable
                      v-model="file"
                      accept=".png, .jpeg, .jpg"
                      @click:close="onFileChange">
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item v-if="editableCompany.type === 'doo' || editableCompany.type === 'jdoo'">
                <v-row class="pt-7">
                  <v-col cols="6"
                    class="pt-0 pb-0 mb-0 mt-0 pr-0">
                    <v-row class="pt-0 pb-0 mb-0 mt-0">
                      <v-col cols="12"
                        class="pt-0 pb-3 mb-0 mt-0">
                        <v-text-field dense
                          outlined
                          class="form-input"
                          label="Matični broj subjekata"
                          :rules="[rules.req]"
                          v-model="editableCompany.legal_info.court_register_id"
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="pt-0 pb-0 mb-0 mt-0">
                      <v-col cols="12"
                        class="pt-0 pb-0 mb-0 mt-0">
                        <v-select outlined
                          dense
                          hide-details
                          class="form-input"
                          :items="courts"
                          label="Sud"
                          v-model="editableCompany.legal_info.court"
                          :rules="[rules.req]">
                        </v-select></v-col></v-row>
                  </v-col>
                  <v-col cols="6"
                    class="pt-0 pb-0 mb-0 mt-0">
                    <v-row class="pt-0 pb-0 mb-0 mt-0">
                      <v-col cols="8"
                        class="pt-0 pb-0 mb-0 mt-0 pr-1">
                        <money-input dense
                          outlined
                          hide-details
                          class="form-input"
                          :currency="editableCompany.legal_info.base_capital_currency"
                          label="Temeljni kapital"
                          :rules="[rules.req]"
                          v-model="editableCompany.legal_info.base_capital"
                          ref="capital">
                        </money-input>
                      </v-col>
                      <v-col cols="4"
                        class="pt-0 pb-0 mb-0 mt-0 pl-0">
                        <v-select label="Valuta"
                          hide-details
                          outlined
                          dense
                          class="form-input"
                          :items="currencies"
                          item-text="name"
                          item-value="name"
                          v-model="editableCompany.legal_info.base_capital_currency">
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="pt-0 pb-0 mb-0"
                    cols="12">
                    <v-row class="pt-3"
                      style="text-align: center">
                      <v-col>
                        <v-row class="pb-3 pr-3">
                          <v-spacer></v-spacer>
                          <v-btn v-if="
                            editableCompany.legal_info &&
                            editableCompany.legal_info.members &&
                            editableCompany.legal_info.members.length > 0
                          "
                            fab
                            style="
                              width: 25px;
                              height: 25px;
                              padding: 0px;
                              border-radius: 50%;
                            "
                            class="fab-add-btn mb-2"
                            @click="openAddBoardMembersForm()"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                        </v-row>

                        <table style="width: 100%"
                          class="styled-table"
                          v-if="
                            editableCompany.legal_info &&
                            editableCompany.legal_info.members &&
                            editableCompany.legal_info.members.length > 0
                          ">
                          <caption class="field-label"
                            style="text-align: left; padding-bottom: 8px">
                            Članovi društva
                          </caption>
                          <thead>
                            <tr>
                              <th width="30%"
                                colspan="1">Ime</th>
                              <th width="35%"
                                colspan="1">Prezime</th>
                              <th width="20%"
                                colspan="1">Direktor</th>
                              <th width="25%"
                                colspan="1"></th>
                            </tr>
                          </thead>
                          <tbody v-if="
                            editableCompany &&
                            editableCompany.legal_info &&
                            editableCompany.legal_info.members
                          ">
                            <tr v-for="(member, index) in editableCompany.legal_info
                              .members"
                              :key="member.id">
                              <td colspan="1">{{ member.first_name }}</td>
                              <td colspan="1">{{ member.last_name }}</td>
                              <td colspan="1">
                                {{ showMainIban(member.ceo) }}
                              </td>
                              <td style="text-align: right"
                                colspan="1">
                                <v-icon class="pr-2 row-action-icon"
                                  @click="
                                    openAddBoardMembersForm(member, index)
                                    ">mdi-pencil-outline</v-icon>
                                <v-icon class="row-action-icon row-action-icon--delete"
                                  @click="removeMember(index)">mdi-delete-outline</v-icon>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-if="
                  !editableCompany.legal_info ||
                  !editableCompany.legal_info.members ||
                  editableCompany.legal_info.members.length === 0
                "
                  style="justify-content: center; margin-top: 50px">
                  <v-btn class="btn-primary"
                    @click="openAddBoardMembersForm()"><v-icon color="#fff"
                      class="pr-1">mdi-plus</v-icon>Dodaj članove
                    društva</v-btn>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-end form-footer-sticky">
          <v-btn id="success"
            class="btn-primary"
            :loading="submitting"
            type="submit">
            <v-icon left small color="#fff">mdi-content-save</v-icon>
            Spremi
          </v-btn>
        </v-card-actions>

        <add-oib ref="addOib"
          @add="onAddOib"> </add-oib>
        <add-iban ref="addIban"
          @add="onAddIban"
          :banks="banks"></add-iban>
        <add-board-members ref="addBoardMembers"
          @add="onAddMember"></add-board-members>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import rules from '@/plugins/rules'
import { df, functions, auth } from '@/plugins/firebase'
import { duck, clone } from '@/plugins/utils'
import AddOib from '@/modules/companies/components/AddOib'
import addIban from '@/modules/companies/components/AddIban'
import CountryFlag from 'vue-country-flag'
import countries from '@/mixins/countries'
import formUtils from '@/mixins/formUtils'
import requestChecker from '@/mixins/requestChecker'
import MoneyInput from '@/components/MoneyInput'
import addBoardMembers from '@/modules/companies/components/AddBoardMembers'
import company from '@/mixins/company'

export default {
  name: 'EditCompanyInline',
  components: { addIban, AddOib, CountryFlag, MoneyInput, addBoardMembers },
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    defaultUrl: '',
    logo: undefined,
    submitting: false,
    editableCompany: {},
    initialCompany: {},
    defultCompany: {},
    companyTypes: [],
    isTaxed: true,
    rules: {
      req: rules.req(),
      eq: rules.eq,
      oib: rules.oib(),
      arrReq: rules.arrReq()
    },
    shakeFlag: false,
    selectedOibs: [],
    taxTypes: [],
    defaultTaxTypes: [],
    change: false,
    file: undefined,
    banks: [],
    bank: {},
    ibans: [],
    members: [],
    courts: [],
    currencies: [{ name: 'EUR' }, { name: 'HRK' }],
    currency: 'EUR',
    tab: null,
    tabs: [],
    activeTab: 'Osnovni podaci',
    newCompany: false
  }),
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'confirm', 'confirmClose'],
  mixins: [countries, formUtils, requestChecker, company],
  computed: {
    basicDataValid () {
      if (!this.editableCompany.name) {
        return false
      }

      if (!this.editableCompany.oib) {
        return false
      }

      if (!this.editableCompany.address) {
        return false
      }

      if (!this.editableCompany.city) {
        return false
      }

      if (!this.editableCompany.country) {
        return false
      }

      if (!this.editableCompany.zip_code) {
        return false
      }

      return true
    },
    bankDataValid () {
      if (!this.editableCompany.bank_accounts || this.editableCompany.bank_accounts.length === 0) {
        return false
      }

      return true
    },
    legalInfoValid () {
      if (this.editableCompany.type === 'doo' || this.editableCompany.type === 'jdoo') {
        if (!this.editableCompany.legal_info.court_register_id) {
          return false
        }

        if (!this.editableCompany.legal_info.base_capital) {
          return false
        }

        if (!this.editableCompany.legal_info.base_capital_currency) {
          return false
        }

        if (!this.editableCompany.legal_info.court) {
          return false
        }

        if (!this.editableCompany.legal_info.members || this.editableCompany.legal_info.members.length === 0) {
          return false
        }

        return true
      }
      return true
    }

  },
  watch: {
    'editableCompany.type' (nv, ov) {
      if (nv !== ov) {
        if (['doo', 'jdoo'].includes(nv)) {
          this.types = clone(this.defaultTaxTypes)
          this.taxTypes = this.types.map((type) => {
            if (type.value !== 'profit') {
              type.disabled = true
            }
            return type
          })
        } else {
          this.taxTypes = clone(this.defaultTaxTypes)
        }
      }
    }
  },
  async mounted () {
    this.defaultTaxTypes = [
      { name: this.$t('$vuetify.companies.taxTypes.profit'), value: 'profit' },
      { name: this.$t('$vuetify.companies.taxTypes.income'), value: 'income' }
    ]

    this.submitting = false

    const editableCompany = clone(this.company)
    if (editableCompany.legal_info && !editableCompany.legal_info.base_capital_currency) {
      editableCompany.legal_info.base_capital_currency = 'HRK'
    }
    this.editableCompany = editableCompany
    this.initialCompany = clone(editableCompany)
    this.newCompany = false

    this.defaultUrl = this.editableCompany.logo || ''
    this.companyTypes = [
      { name: this.$t('$vuetify.companies.types.doo'), value: 'doo' },
      { name: this.$t('$vuetify.companies.types.jdoo'), value: 'jdoo' },
      { name: this.$t('$vuetify.companies.types.crafts'), value: 'obrt' },
      {
        name: this.$t('$vuetify.companies.types.pcrafts'),
        value: 'pausalni_obrt'
      }
    ]

    this.changeCompanyType()

    if (this.editableCompany.legal_info?.members) {
      this.members = this.editableCompany.legal_info.members
    }

    this.$nextTick(() => {
      if (this.editableCompany.associated_oibs) {
        Object.keys(this.editableCompany.associated_oibs).forEach((key) => {
          this.selectedOibs.push({
            oib: this.editableCompany.associated_oibs[key],
            countryCode: key
          })
        })
      }
      setTimeout(() => {
        this.setFormInitalValue(this.$refs.editCompanyForm)
      }, 50)
    })

    this.banks = await this.getBanks()
    this.courts = await this.getCourts()
    this.setBank(this.editableCompany.bank_accounts.find((item) => item.default))
    this.registerRequestParams(this.editableCompany)
  },
  methods: {
    changeCompanyType () {
      this.tabs = []
      if (this.editableCompany.type === 'doo' || this.editableCompany.type === 'jdoo') {
        this.tabs = [
          { id: 0, name: 'Osnovni podaci', icon: 'mdi-note-edit-outline' },
          { id: 1, name: 'Banka', icon: 'mdi-bank-outline' },
          { id: 2, name: 'Logo', icon: 'mdi-panorama-variant-outline' },
          { id: 3, name: 'Poslovni podaci', icon: 'mdi-office-building-outline' }]

        if (!this.editableCompany.legal_info) {
          this.editableCompany.legal_info = {
            bank: {},
            base_capital: 0,
            base_capital_currency: 'EUR',
            court: '',
            court_register_id: '',
            members: []
          }
        }
      } else {
        this.tabs = [
          { id: 0, name: 'Osnovni podaci', icon: 'mdi-note-edit-outline' },
          { id: 1, name: 'Banka', icon: 'mdi-bank-outline' },
          { id: 2, name: 'Logo', icon: 'mdi-panorama-variant-outline' }]
      }

      this.$forceUpdate()
    },
    showMainIban (def) {
      switch (def) {
        case true:
          return 'DA'
        case false:
          return 'NE'
      }
    },
    changeTab (tab) {
      this.changeCompanyType()

      if (tab === -1) {
        this.activeTab = 'Osnovni podaci'
      }

      this.activeTab = tab
    },
    openAddBoardMembersForm (existing = null, idx = undefined) {
      this.$refs.addBoardMembers.open(existing, idx)
    },
    removeMember (index) {
      this.editableCompany.legal_info.members = this.editableCompany.legal_info.members.filter((_, i) => i !== index)
    },
    onAddMember (newMember) {
      if (newMember.idx === 0 || newMember.idx) {
        this.editableCompany.legal_info.members[newMember.idx] = newMember
      } else if (this.editableCompany.legal_info.members !== undefined && this.editableCompany.legal_info.members !== null && this.editableCompany.legal_info.members.length > 0) {
        this.editableCompany.legal_info.members.push(newMember)
      } else {
        this.editableCompany.legal_info.members = []
        this.editableCompany.legal_info.members.push(newMember)
      }
      this.$forceUpdate()
    },
    createImage (file) {
      const reader = new FileReader()

      reader.onload = (e) => {
        if (!e.target.result?.includes('data:image')) {
          this.showMsgBox({
            text: 'Nedopušteni tip datoteke. Dozvoljeni tipovi su .jpeg, .jpg i .png.',
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'error'
          })
          this.file = undefined
          return
        }

        if (e.target.result) {
          this.editableCompany.logo = e.target.result
          this.$forceUpdate()
        }
      }
      reader.readAsDataURL(file)
    },
    onFileChange (file) {
      if (!file) {
        const defaultUrl = this.defaultUrl
          ? this.defaultUrl
          : require('@/assets/unknown_profile.jpg')
        this.editableCompany.logo = defaultUrl
      } else {
        this.createImage(file)
      }
    },
    setFocusOnNext () {
      document.getElementById('associatedOib').focus()
    },
    openAddOibForm () {
      this.$refs.addOib.open()
    },
    onAddOib (item) {
      this.selectedOibs.push(item)
      this.focusOnForm()
    },
    removeOib (oib) {
      this.selectedOibs = this.selectedOibs.filter((o) => o !== oib)
    },
    preventTextInput (form, e) {
      if (e.keyCode !== 9 && e.keyCode !== 27) {
        switch (form) {
          case 'iban':
            this.$refs.addIban.open()
            break
          case 'oib':
            this.$refs.addOib.open()
            break
          default:
            break
        }
      }
    },
    openIbanForm () {
      this.$refs.addIban.open()
    },
    onAddIban (ibanStruct) {
      if (ibanStruct.default === true) {
        this.editableCompany.bank_accounts = this.editableCompany.bank_accounts.map((item) => {
          item.default = false
          return item
        })
      }
      const iban = ibanStruct.initialIban || ibanStruct.iban
      if (this.editableCompany.bank_accounts.some((item) => item.iban === iban)) {
        this.editableCompany.bank_accounts = this.editableCompany.bank_accounts.map((item) => {
          if (item.iban === iban) {
            return ibanStruct
          } else {
            return item
          }
        })
      } else {
        this.editableCompany.bank_accounts.push(ibanStruct)
      }
      this.bank = this.editableCompany.bank_accounts.find((item) => item.default) || {}

      this.swift = this.bank.swift
      this.focusOnForm()
    },
    editIban (ibanStruct) {
      this.$refs.addIban.open(ibanStruct)
    },
    removeIban (ibanStruct) {
      this.editableCompany.bank_accounts = this.editableCompany.bank_accounts.filter(
        (ibanStr) => ibanStr.iban !== ibanStruct.iban
      )
    },

    async checkDuplicateOib () {
      const query = df
        .collection('companies/')
        .where('oib', '==', this.editableCompany.oib)
      let found = false
      await query.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          if (doc.data().oib === this.editableCompany.oib) {
            found = true
          }
        })
      })
      return found
    },

    async getBanks () {
      const bankCollection = await df.doc('project_constants/banks').get()
      if (!bankCollection?.data()?.banks) return []
      return Object.values(bankCollection.data().banks)
    },
    async getCourts () {
      const courtsCollection = await df.doc('project_constants/courts').get()
      if (!courtsCollection?.data()?.courts) return []
      return courtsCollection.data().courts
    },
    setBank (defaultBank = undefined) {
      if (!defaultBank) return
      if (!defaultBank.iban || defaultBank.iban.length < 11) return
      const bankPrefix = defaultBank.iban.substr(4, 7)
      const bank = this.banks.find(
        (bank) => bank.leading_bank_num === bankPrefix
      )
      this.bank = { ...defaultBank, bank }
    },
    // openLegalInfoForm () {
    //   this.$refs.legalInfo.open(this.company.legal_info, this.bank)
    // },
    focusOnForm () {
      this.$refs.oib.focus()
    },

    async submit () {
      const that = this

      if (!this.$refs.editCompanyForm.validate()) { return }

      if (!this.basicDataValid) {
        this.tab = 0
        return
      }

      if (!this.bankDataValid) {
        this.tab = 1
        return
      }

      if (this.editableCompany.type === 'jdoo' || this.editableCompany.type === 'doo') {
        var defaultFound = false
        this.editableCompany.bank_accounts.forEach(bank => {
          if (bank.default) {
            defaultFound = true
            var lgBank = {
              name: bank.bank.name,
              country: bank.bank.country,
              zip_code: bank.bank.zip_code,
              city: bank.bank.city,
              address: bank.bank.street
            }
            this.editableCompany.legal_info.bank = lgBank
          }
        })

        if (!defaultFound) {
          this.showMsgBox({ text: 'Nije pronađen glavni IBAN, molimo postavite glavni IBAN kako bi nastavili.', actions: ['ok'], cancelBtnText: 'OK', color: 'error' })
          return
        }
      }

      if ((this.editableCompany.type === 'jdoo' || this.editableCompany.type === 'doo') && !this.legalInfoValid) {
        this.tab = 3
        return
      }

      if ((this.editableCompany.type === 'obrt' || this.editableCompany.type === 'pausalni_obrt') && this.editableCompany.legal_info) {
        this.editableCompany.legal_info = null
      }

      if (duck(this.editableCompany, this.initialCompany)) {
        this.showMsgBox({ text: this.$t('$vuetify.errors.noChangesInEntities'), actions: ['ok'], cancelBtnText: 'OK', color: 'error' })
        return
      }

      if (this.checkCompanyIsSameAsInitial(this.initialCompany, this.editableCompany)) {
        this.showMsgBox({ text: this.$t('$vuetify.errors.noChangesInEntities'), actions: ['ok'], cancelBtnText: 'OK', color: 'error' })
        return
      }

      if (duck(this.defultCompany, this.editableCompany) && !this.logo) return

      if (!this.$refs.editCompanyForm.validate()) {
        return
      }

      if (this.editableCompany.type === 'jdoo' || this.editableCompany.type === 'doo') {
        var baseCapital = this.editableCompany.legal_info.base_capital
        if (typeof (this.editableCompany.legal_info.base_capital) === 'string') {
          baseCapital = clone(parseInt(
            this.$refs.capital.currencyToFloat(this.editableCompany.legal_info.base_capital) * 100
          ))
        }
      }

      this.submitting = true
      if (
        this.editableCompany.iban &&
        this.editableCompany.bank_accounts &&
        this.editableCompany.bank_accounts.length > 0
      ) {
        this.editableCompany.bank_accounts[0].iban = this.editableCompany.iban
      }
      try {
        if (this.editableCompany.associated_oib) {
          delete this.editableCompany.associated_oib
        }
        const oibs = this.selectedOibs.reduce(
          (oibs, it) =>
            Object.assign(oibs, { [it.countryCode.toLowerCase()]: it.oib }),
          {}
        )

        var resource = ''
        var operation = 'update'
        if (this.newCompany) {
          operation = 'set'
          const duplicateOib = await this.checkDuplicateOib()
          if (duplicateOib === true) {
            that.showMsgBox({
              text: 'Oib ' + this.editableCompany.oib + ' je već registriran.',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
            that.$refs.oib.reset()
            this.submitting = false
            return
          }
        } else {
          resource = this.editableCompany.id
        }

        this.editableCompany.associated_oibs = oibs
        const payload = {
          action: {
            operation: operation,
            entity: 'company',
            resource_id: resource,
            params: clone(this.editableCompany)
          }
        }

        if (payload.action.params.legal_info?.base_capital) {
          payload.action.params.legal_info.base_capital = baseCapital
        }

        // const cleanParam = this.getCleanParams(this.company)
        // Object.keys(cleanParam).forEach((key) => {
        //   delete payload.action.params[key]
        // })

        if (payload.action.params.logo) {
          if (payload.action.params.logo !== this.defaultUrl) {
            payload.action.params.logo = payload.action.params.logo.split(',')[1]
          }
        }

        if (payload.action.params.active_products) {
          delete payload.action.params.active_products
        }

        if (payload.action.params.warehouse) {
          delete payload.action.params.warehouse
        }

        if (payload.action.params.logo === '') {
          delete payload.action.params.logo
        }

        payload.action.params.user_id = auth.currentUser.uid

        var companyApi = functions.httpsCallable('companyapi')
        that.$emit('saved', that.editableCompany)

        companyApi({
          action: {
            operation: operation,
            entity: 'company',
            resource_id: resource,
            params: payload.action.params
          }
        })
          .then((result) => {
            if (result.data.code === 200) {
              that.selectedOibs = []
              this.submitting = false
            } else {
              this.submitting = false
              that.selectedOibs = []
              that.showMsgBox({
                text: 'Dogodila se greška',
                actions: ['cancel'],
                cancelBtnText: 'OK',
                color: 'error'
              })
            }
          })
      } catch (err) {
        this.showMsgBox({
          text: err || 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        this.submitting = false
      }
    }
  }
}
</script>
<style scoped>
.companyType>>>.v-input__append-outer {
  margin-top: 0 !important;
  margin-left: 0 !important;
}

.v-text-field>>>.v-input__slot {
  border-radius: 10px;
}

.form-input >>> .v-input__slot {
  border-radius: 12px !important;
  background: #ffffff !important;
  min-height: 40px !important;
}
.form-input >>> fieldset { border-color: #e5e7eb !important; border-width: 1px !important; border-radius: 12px !important; }
.form-input >>> .v-input__slot:hover fieldset { border-color: #00BCD4 !important; }
.form-input.v-input--is-focused >>> fieldset { border-color: #00BCD4 !important; border-width: 2px !important; }
.form-input >>> input { font-size: 13px !important; }

.btn-primary {
  display: flex; align-items: center; gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important; color: #fff !important;
  border: none !important; border-radius: 10px;
  font-size: 13px; font-weight: 700; cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
  text-transform: none !important;
}
.btn-primary:hover:not(:disabled) { background-color: #0097A7 !important; }
.btn-primary:disabled { opacity: 0.4; cursor: not-allowed; box-shadow: none; }

.fab-add-btn {
  background-color: #00BCD4 !important;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3) !important;
  transition: background-color 0.15s;
}
.fab-add-btn:hover { background-color: #0097A7 !important; }

.field-label {
  font-size: 11px;
  font-weight: 700;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.styled-table {
  border-collapse: collapse;
}
.styled-table thead th {
  background: #F8FAFC;
  color: #64748B;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 10px 8px;
  border-bottom: 1px solid #E2E8F0;
}
.styled-table tbody td {
  padding: 10px 8px;
  font-size: 13px;
  color: #374151;
  border-bottom: 1px solid #F1F5F9;
}

.row-action-icon {
  color: #94A3B8 !important;
  cursor: pointer;
}
.row-action-icon--delete:hover {
  color: #E53935 !important;
  background: rgba(229, 57, 53, 0.08);
  border-radius: 4px;
}

.shake-info {
  animation: shake 0.5s;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }

  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }

  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }

  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }

  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }

  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }

  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }

  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }

  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }

  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

.addIban>>>.v-input__prepend-inner {
  display: inline-block !important;
}

.addIban>>>.v-input__slot {
  display: inline !important;
}

.addIban>>>.v-text-field__slot {
  display: inline-block !important;
}

/* .my-input.v-input .v-input__slot {
  border-radius: 100px;
} */
.textField>>>.v-input__slot {
  border-radius: 12px !important;
}

td {
  text-align: left;
}

th {
  text-align: left;
}

.card-company {
  border-radius: 8px !important;
}

.business-settings-inline-form {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.business-settings-inline-form>>>form {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card__text {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}
.business-settings-inline-form>>>.v-window,
.business-settings-inline-form>>>.v-window__container {
  height: auto !important;
  overflow: visible !important;
}

.form-footer-sticky {
  flex: 0 0 auto;
  background: #fff;
  border-top: 1px solid #F3F4F6;
  padding: 16px 24px !important;
}

.pill-tabs {
  margin: 4px 0 24px 0;
}
.pill-tabs>>>.v-tabs-bar {
  background: transparent !important;
  height: auto !important;
}
.pill-tabs>>>.v-slide-group__wrapper {
  padding: 4px 0;
}
.pill-tabs>>>.v-tabs-slider-wrapper {
  display: none !important;
}
.pill-tabs>>>.v-tab {
  min-width: 0;
  height: auto;
  padding: 8px 16px !important;
  margin-right: 8px;
  border-radius: 12px !important;
  background: rgba(241, 245, 249, 0.8);
  color: #64748B !important;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.pill-tabs>>>.v-tab:hover {
  background: rgba(226, 232, 240, 0.6);
}
.pill-tabs>>>.v-tab--active {
  background: #00BCD4 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 188, 212, 0.3);
}
</style>
